function attachRemoveEventListeners() {
  const removeButtons = document.querySelectorAll(".remove-swatch-button");

  removeButtons.forEach((btn) => {
    btn.addEventListener("click", async function (e) {
      e.preventDefault();

      const lineItemKey = btn.dataset.lineItemKey;
      const swatchToRemove = btn.dataset.removeValue;

      if (!lineItemKey || !swatchToRemove) return;

      // Fetch full cart
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const allSwatchItems = cart.items.filter(
        (item) =>
          item.properties &&
          (item.properties._sample_type === "swatch" ||
            item.properties.sample_type === "swatch")
      );

      const variantId = allSwatchItems[0]?.variant_id;
      const remainingSwatches = [];

      // Collect all swatches except the one being removed
      for (const item of allSwatchItems) {
        Object.entries(item.properties).forEach(([key, value]) => {
          if (
            key.startsWith("Swatch Item ") &&
            value !== swatchToRemove
          ) {
            remainingSwatches.push(value);
          }
        });

        // Remove the original swatch line item
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      }

      // Re-add chunks of remaining swatches in sets of 5
      for (let i = 0; i < remainingSwatches.length; i += 5) {
        const chunk = remainingSwatches.slice(i, i + 5);
        const properties = {
          _sample_type: "swatch",
          _swatch_count: chunk.length.toString(),
          "Sample Count": `${chunk.length} sample${chunk.length !== 1 ? "s" : ""}`,
        };

        chunk.forEach((swatch, index) => {
          properties[`Swatch Item ${index + 1}`] = swatch;
        });

        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties,
          }),
        });
      }

      // Wait briefly for Shopify's cart to settle, then update counter
      await new Promise(resolve => setTimeout(resolve, 100));
      await updateCartCounter();

      // Live DOM cart refresh
      const response = await fetch("/cart");
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      const updatedCartList = doc.querySelector(".cartitems--list");
      const currentCartList = document.querySelector(".cartitems--list");

      if (updatedCartList && currentCartList) {
        currentCartList.innerHTML = updatedCartList.innerHTML;
        attachRemoveEventListeners(); // Rebind buttons
      }

      // Broadcast the final cart state
      await broadcastCartUpdate();
    });
  });
}

async function updateCartCounter() {
  const freshCart = await fetch('/cart.js?' + Date.now()).then(res => res.json());
  const cartCounter = document.querySelector('[data-header-cart-count]');
  if (cartCounter) {
    cartCounter.setAttribute('data-header-cart-count', freshCart.item_count);
    if (freshCart.item_count > 0) {
      cartCounter.classList.remove('hidden');
      cartCounter.classList.add('visible');
    } else {
      cartCounter.classList.remove('visible');
      cartCounter.classList.add('hidden');
    }
  }
}

// Expose the function on window so other scripts (compact snippets / quick-shop)
// can call it for re-binding after they update cart HTML.
window.attachRemoveEventListeners = attachRemoveEventListeners;

document.addEventListener("DOMContentLoaded", attachRemoveEventListeners);

// When removing/rebuilding swatch items we should broadcast the updated cart
// so other scripts (e.g. header cart counters) can immediately refresh.
// Note: the main snippet also listens for `cart:updated` events.
async function broadcastCartUpdate() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  } catch (err) {
    console.warn('broadcastCartUpdate failed', err);
  }
}

// Try to broadcast after any cart DOM refresh. Keep original behavior intact
// by calling broadcastCartUpdate where the DOM refresh completes.
// We'll monkey-patch the existing rebind point: call broadcast after DOM update.
const originalAttach = attachRemoveEventListeners;
attachRemoveEventListeners = function () {
  originalAttach();
  // fire an async update so header/cart-count can react
  setTimeout(() => {
    broadcastCartUpdate();
  }, 50);
};